import __request__ from "routing/request";
export function getByIds(body) {
  return __request__("POST", "/events/byIds", body, {}, {
    "Accept": ["application/json"]
  });
}
export function histogram(JSONbody) {
  return __request__("POST", "/events/histogram", JSONbody, {}, {
    "Accept": ["application/json"]
  });
}
export function search(JSONbody) {
  return __request__("POST", "/events/search", JSONbody, {}, {
    "Accept": ["application/json"]
  });
}
export function getById(event_id) {
  return __request__("GET", `/events/${event_id}`, null, {}, {
    "Accept": ["application/json"]
  });
}
